var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.671875 1.00067L13.3385 1.00067",
    stroke: "#DDDDEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.00391 1.00067L2.00391 8.33336C2.00391 9.8859 2.29096 10.3929 3.62225 11.1917L5.63192 12.3975C6.30036 12.7985 6.6346 12.9991 7.00391 12.9991C7.37322 12.9991 7.70745 12.7985 8.3759 12.3975L10.3856 11.1917C11.7168 10.3929 12.0039 9.8859 12.0039 8.33336L12.0039 1.00067",
    stroke: "#DDDDEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66927 7.66732L5.33594 7.66732M8.66927 4.33398L5.33594 4.33398",
    stroke: "#DDDDEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanner);
export default __webpack_public_path__ + "static/media/banner.189a8678f5b9cd3665f3c90c89895c99.svg";
export { ForwardRef as ReactComponent };